/** Единый cache-buster для фавиконов и PWA-иконок (менять при смене файлов). */
export const KREDAFI_ICON_CACHE = "kf20260910_v3";
